import type { McpTestResultDto } from '@dbrain/shared';

/**
 * 16c.5 (D-405, D-406): "Bağlantıyı dene" that failed, as Bağlantı ekle's card says it. A web page where a server
 * should be is said in plain words, its details are the status and the media type (never the page); an address that
 * is a GitHub repository adds the way to Skill ekle with the link. DOM-free, so it is tested alone.
 */
type T = (key: string, options?: Record<string, unknown>) => string;

export interface TestFailureView {
  /** the paragraphs under "Bağlantı kurulamadı." */
  body: string[];
  /** "Teknik ayrıntılar" */
  details: string;
  /** the link to carry to Skill ekle's Bağlantıdan, when the address is a GitHub repository */
  githubLink: string | null;
}

/** github.com's own pages, never a repository's owner */
const NOT_OWNERS = new Set([
  'about',
  'account',
  'apps',
  'codespaces',
  'collections',
  'contact',
  'customer-stories',
  'dashboard',
  'enterprise',
  'events',
  'explore',
  'features',
  'issues',
  'join',
  'login',
  'logout',
  'marketplace',
  'new',
  'notifications',
  'organizations',
  'orgs',
  'pricing',
  'pulls',
  'search',
  'security',
  'settings',
  'site',
  'sponsors',
  'team',
  'topics',
  'trending',
  'users',
]);

/** The address as typed when it is a GitHub repository (github.com/<owner>/<repo>…), else null. */
export function githubRepositoryLink(typed: string): string | null {
  const text = typed.trim();
  if (!text) return null;
  let url: URL;
  try {
    url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  const host = url.hostname.toLowerCase();
  if (host !== 'github.com' && host !== 'www.github.com') return null;
  const [owner, repo] = url.pathname.split('/').filter(Boolean);
  if (!owner || !repo || NOT_OWNERS.has(owner.toLowerCase())) return null;
  return text;
}

export function testFailureView(result: Extract<McpTestResultDto, { ok: false }>, typedUrl: string, t: T): TestFailureView {
  const body: string[] = [];
  let details = result.message;
  if (result.code === 'mcp_web_page' && result.answer) {
    body.push(t('connectors.add.webPage'));
    details = t('connectors.add.webPageDetails', { status: result.answer.status, type: result.answer.contentType });
  }
  const githubLink = githubRepositoryLink(typedUrl);
  if (githubLink) body.push(t('connectors.add.githubRepo'));
  return { body, details, githubLink };
}
